import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import MultiSelectList from "../../../components/multi-select-list/multi-select-list";
import { IListItem } from "../../../interface/list-item";
import { IRootState } from "../../../redux/root.reducer";
import { dataBrowserListSetFiltersAction } from "../redux/lists.actions";

interface IOwnProps {
    inputMask?: RegExp | string;
}

const selector = createSelector(
    (state: IRootState) => state.countries,
    (state: IRootState) => state.dataBrowserList.filters,
    (countries, filters) => ({
        options: countries.data ?? [],
        isLoading: countries.isLoading,
        filters,
        selectedItems: (countries.data ?? []).filter((country) =>
            filters.country?.includes(country.id),
        ),
    }),
);

const CountryFilter = ({ inputMask }: IOwnProps) => {
    const { options, isLoading, selectedItems, filters } =
        useSelector(selector);
    const dispatch = useDispatch();

    const onChange = (selectedCountries: Array<IListItem>) =>
        dispatch(
            dataBrowserListSetFiltersAction({
                ...filters,
                country: selectedCountries.map(({ id }) => id),
            }),
        );
    return !isLoading ? (
        <MultiSelectList
            onChange={onChange}
            selectedItems={selectedItems}
            options={options}
            multiline={true}
            clearAllOption={true}
            inputMask={inputMask}
            menuWidth={300}
        />
    ) : (
        <Skeleton />
    );
};

export default CountryFilter;
